<mat-list>
  <mat-list-item class="fw-bold"> {{title}} </mat-list-item>
  @for (item of list; track item; let last = $last) {
    <mat-list-item >
      <div class="flex w-100 justify-content-between">
        {{item.name}}
        <span class="float-end fw-bold">{{item.value}}</span>
      </div>
      @if (!last) {
        <mat-divider [inset]="true"></mat-divider>
      }
    </mat-list-item>
  }
</mat-list>
